import React from "react";
import {
  FaChalkboardTeacher,
  FaHistory,
  FaShieldAlt,
  FaStar,
  FaUsers,
  FaUserTie,
} from "react-icons/fa";

import { formatNumber } from "../utils/leClubUtils";

const cards = [
  {
    key: "teamTotal",
    label: "Équipe",
    helper: "Membres visibles",
    icon: FaUsers,
    tone: "bg-blue-50 text-blue-600 dark:bg-blue-500/10 dark:text-blue-300",
  },
  {
    key: "teachers",
    label: "Enseignants",
    helper: "Encadrement",
    icon: FaChalkboardTeacher,
    tone:
      "bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-300",
  },
  {
    key: "board",
    label: "Bureau",
    helper: "Dirigeants",
    icon: FaUserTie,
    tone:
      "bg-violet-50 text-violet-600 dark:bg-violet-500/10 dark:text-violet-300",
  },
  {
    key: "usersTotal",
    label: "Utilisateurs",
    helper: "Comptes app",
    icon: FaShieldAlt,
    tone:
      "bg-orange-50 text-orange-600 dark:bg-orange-500/10 dark:text-orange-300",
  },
  {
    key: "historyImages",
    label: "Images",
    helper: "Historique",
    icon: FaHistory,
    tone: "bg-rose-50 text-rose-600 dark:bg-rose-500/10 dark:text-rose-300",
  },
  {
    key: "demo",
    label: "Démo",
    helper: "Membres démonstration",
    icon: FaStar,
    tone: "bg-amber-50 text-amber-600 dark:bg-amber-500/10 dark:text-amber-300",
  },
];

export default function ClubStats({ loading, stats }) {
  const isLoading = loading.team || loading.users || loading.settings;

  return (
    <section className="grid gap-4 sm:grid-cols-2 xl:grid-cols-6">
      {cards.map((card) => {
        const Icon = card.icon;

        return (
          <article
            key={card.key}
            className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm shadow-slate-200/60 transition hover:-translate-y-1 hover:shadow-lg hover:shadow-slate-200/80 dark:border-slate-800 dark:bg-slate-900 dark:shadow-none"
          >
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
                  {card.label}
                </p>

                {isLoading ? (
                  <div className="mt-3 h-8 w-16 animate-pulse rounded-xl bg-slate-100 dark:bg-slate-800" />
                ) : (
                  <p className="mt-2 text-3xl font-bold text-slate-950 dark:text-white">
                    {formatNumber(stats?.[card.key])}
                  </p>
                )}

                <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">
                  {card.helper}
                </p>
              </div>

              <span
                className={`grid h-11 w-11 shrink-0 place-items-center rounded-2xl ${card.tone}`}
              >
                <Icon />
              </span>
            </div>
          </article>
        );
      })}
    </section>
  );
}